export default {
  'menu.payment.userPaymentReview': 'User Payment Review (Migrated)',
  'menu.marketing.marketingCampaigns': 'Marketing Campaigns (Migrated)',
  'menu.marketing.promoCampaigns': 'Promo Campaign List (Migrated)',
  'menu.marketing.newPromoCampaign': 'Add New Promo',
  'menu.marketing.duplicatePromoCampaign': 'Duplicate Promo Campaign',
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.reports': 'Reports',
  'menu.payment': 'Payment',
  'menu.payment.payin': 'Payin Report',
  'menu.payment.monthlyPayinDueMigrated': 'Monthly Payin Due (Migrated)',
  'menu.payment.payinDetails': 'Payin Details',
  'menu.payment.payout': 'Payout Report',
  'menu.payment.monthlyPayoutDueMigrated': 'Monthly Payout Due New (Migrated)',
  'menu.payment.payinOverrides': 'Payin Overrides Report',
  'menu.payment.paymentClaim': 'Payment Claim Report',
  'menu.payment.payoutFinance': 'Payout Finance Report',
  'menu.payment.refundRequests': 'Refund Requests',
  'menu.payment.payinClaims': 'Pay-in Claims',
  'menu.user': 'User',
  'menu.user.profile': 'User Profile',
  'menu.user.profileDetail': 'User Profile Detail',
  'menu.user.sanctionedUser': 'Sanctioned User',
  'menu.risk': 'Risk',
  'menu.risk.amlRequests': 'AML Requests',
  'menu.risk.proofOfIncome': 'Proof Of Income',
  'menu.risk.watchlist': 'Watchlist',
  'menu.dvsRequests': 'DVS Requests',
  'menu.dvsRequests.mobileValidation': 'Mobile Validation',
  'menu.onboarding': 'Onboarding',
  'menu.onboarding.agreementContract': 'Agreement Contract',
  'menu.onboarding.agreementContractDetail': 'Agreement Contract Detail',
  'menu.onboarding.nationalId': 'National ID',
  'menu.card': 'Card',
  'menu.card.niApisConsumption': 'NI APIs Consumption',
  'menu.card.hubsLocations': 'Hubs Locations',
  'menu.card.cashbackTransactions': 'Cashback Transactions',
  'menu.cardCenter': 'Card Center',
  'menu.cardCenter.p2pTransfers': 'Transfers',
  'menu.cardCenter.p2pRequiresAttention': 'Requires Attention Transfers',
  'menu.cardShopsRewards': 'Card Shops & Rewards',
  'menu.cardShopsRewards.merchants': 'Merchants',
  'menu.cardShopsRewards.merchantsAdd': 'Add Merchant',
  'menu.cardShopsRewards.merchantsEdit': 'Edit Merchant',
  'menu.cardShopsRewards.offers': 'Offers',
  'menu.cardShopsRewards.offersAdd': 'Add Offer',
  'menu.cardShopsRewards.offersEdit': 'Edit Offer',
  'menu.cardShopsRewards.offersDuplicate': 'Duplicate Offer',
  'menu.cardShopsRewards.cashbackOffers': 'Card CashBack (Migrated)',
  'menu.cardShopsRewards.cashbackOffersAdd': 'Add Card CashBack Offer',
  'menu.cardShopsRewards.cashbackOffersEdit': 'Edit Card CashBack Offer',
  'menu.cardShopsRewards.cardPromoCodeCampaigns':
    'Card Promo Code Campaign (Migrated)',
  'menu.cardShopsRewards.cardPromoCodeCampaignsNew':
    'New Card Promo Code Campaign',
  'menu.integration': 'Integration',
  'menu.integration.payinMerchants': 'Payin Merchants',
  'menu.integration.historyAnalytics': 'History & Analytics',
  'menu.integration.userKyc': 'User KYC Report',
  'menu.admin': 'Admin',
  'menu.admin.accessManagement': 'Access Management',
  'menu.payoutCenter': 'Payout Center',
  'menu.payoutCenter.readyForPayout': 'Ready for Payout',
  'menu.payoutCenter.batchesConfiguration': 'Batches Configuration',
  'menu.payoutCenter.batchesHistory': 'Batches History',
  'menu.payoutCenter.batchesCenter': 'Batches Center',
  'menu.circles': 'Circles',
  'menu.circles.dashboard': 'Circles Dashboard',
  'menu.circles.leaveBundleRequests': 'Leave Bundle Requests (Migrated)',
  'menu.circles.leaveRequests': 'Leave Requests',
  'menu.circles.circlesMigrated': 'Circles (Migrated)',
  'menu.circles.bundlingEngine': 'Bundling Engine',
  'menu.circles.bundlingEngineAdd': 'New Bundling Rule',
  'menu.marketing': 'Marketing',
  'menu.marketing.deeplinkTypes': 'Manage Bundling Deeplink',
  'menu.corporate': 'Corporate',
  'menu.corporate.organization': 'Organization Report',
  'menu.corporate.organizationDetails': 'Organization Details',
  'menu.marketing.marketingGoals': 'Marketing Goals',
  'menu.marketing.marketingCarousels': 'Marketing Carousels',
  'menu.quotaManagement': 'Quota Management',
  'menu.quotaManagement.hierarchy': 'Hierarchy',
  'menu.quotaManagement.dashboard': 'Dashboard',
  'menu.quotaManagement.myQuota': 'My quota',
  'menu.quotaManagement.slotAllocation': 'Slot allocation',
  'menu.operations': 'Operations',
  'menu.operations.deadLetterMessages': 'Dead Letter Messages',
  'menu.operations.deadLetterMessagesDetail': 'Dead Letter Message Details',
  'menu.reports.userReports.sanctionedUser': 'Sanctioned User',
  'menu.refunds': 'Refunds',
  'menu.pricingManagement': 'Pricing Management',
  'menu.pricingManagement.rules': 'Rules',
  'menu.pricingManagement.distribution': 'Distribution',
  'menu.moneyfellowsServices': 'Moneyfellows Services',
  'menu.moneyfellowsServices.requests': 'Moneyfellows Services Requests',
  'menu.pricingManagement.segments': 'Segments',
  'menu.pricingManagement.segmentsAdd': 'New Segment',
  'menu.pricingManagement.segmentsEdit': 'Edit Segment',
  'menu.pricingManagement.audit': 'Audit',
};
